import { httpPost, httpGet, httpDelete, httpPut } from '@/utils/request'

//登录
export function weblogin(params = { dbtable: 'autoHPO' }) {
    return httpPost({
        url: '/weblogin',
        data: params
    })
}
export function newuseremail(params) {
    return httpPut({
        url: '/newuseremail',
        data: params
    }, 2)
}

//上传临床信息
export function webclinicalput(params) {
    return httpPut({
        url: '/webclinicalput',
        data: params
    })
}

//搜索hpo
export function webhpoinfo(params) {
    return httpGet({
        url: '/webhpoinfo?',
        data: {
            term: params
        }
    })
}

//上传临床信息
export function webgeneput(params) {
    return httpPut({
        url: '/webgeneput',
        data: params
    })
}



// WEBPACK FOOTER //
// ./src/api/index.js